import TextField from '@mui/material/TextField';
import Button from '../../atoms/Button';
import MessageBar from '../../atoms/MessageBar';

const CreateNewHomeCat = ({ createNewAcc }) => {
  return (
    <>
      <header className='text-xl font-bold' data-cy='homecat-title-text'>
        Create New Account
      </header>
      <div className='my-4'>
        <div className='my-4'>
          <TextField
            id='newAccName'
            helperText='Full name'
            label='Name'
            name='newAccName'
            defaultValue=''
            required
            fullWidth
          />
        </div>
        <div className='my-4'>
          <TextField
            id='newAccUser'
            helperText='Lowercased string with no spaces or special characters'
            label='Username'
            name='newAccUser'
            defaultValue=''
            required
            fullWidth
          />
        </div>
        <div className='my-4'>
          <TextField
            id='newAccPassword'
            helperText='Complex alphanumeric password'
            label='Password'
            defaultValue=''
            name='newAccPassword'
            required
            fullWidth
          />
        </div>

        <div className='my-4 text-center'>
          <Button testid='create-acc-button' callback={createNewAcc}>
            Save
          </Button>
        </div>
      </div>
    </>
  );
};

export default CreateNewHomeCat;
